export const BillingUniqueTariffsColumns = [
    {
        name: 'Компания',
        key: 'name',
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Статус',
        key: 'billing',
    },
]
